/** Maps the date-range picker's "last N days" selection to API date params; 0 or less means all time. */
export function daysToDateRange(days: number): { startDate?: string; endDate?: string } {
  if (days <= 0) return {};

  const end = new Date();
  // Use full-day boundaries in the local timezone so the range
  // includes the entire current day and the correct number of
  // preceding days.
  end.setHours(23, 59, 59, 999);

  const start = new Date();
  // For "last N days", we want an inclusive range of N calendar days
  // ending today. That means today counts as day 1, so we subtract
  // (days - 1) from the current date.
  start.setDate(start.getDate() - (days - 1));
  start.setHours(0, 0, 0, 0);

  return {
    startDate: start.toISOString(),
    endDate: end.toISOString(),
  };
}

/** Human label for a "last N days" selection, used in card titles and column headers. */
export function formatPeriodLabel(days: number): string {
  return days <= 0 ? 'All Time' : `Last ${days}d`;
}
